import { Controller } from "@hotwired/stimulus"

// Toggles fields that only make sense for flat-like property types (floor, floors in
// building) vs house-like types (house, semi_detached, terraced_house — plot area).
// The house-type list comes from the select's data attribute so it stays in sync with
// Pro::WorkspaceProperty::HOUSE_TYPES without duplicating it in JS.
export default class extends Controller {
  static targets = ["typeSelect", "flatOnlyField", "houseOnlyField"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasTypeSelectTarget) return

    const houseTypes = JSON.parse(this.typeSelectTarget.dataset.houseTypes || "[]")
    const isHouseLike = houseTypes.includes(this.typeSelectTarget.value)

    this.flatOnlyFieldTargets.forEach((field) => field.classList.toggle("hidden", isHouseLike))
    this.houseOnlyFieldTargets.forEach((field) => field.classList.toggle("hidden", !isHouseLike))
  }
}
